import React, { useState } from 'react';
import { TablePagination, Card, CardContent, Container, Stack, Grid, Box, FormControl, TextField, InputAdornment, Divider } from "@mui/material";
import Paper from '@mui/material/Paper';
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow} from '../tabs_style';
import TableRow from '@mui/material/TableRow';

export default function ConReingresoLeyAnterior() {
    const [tabIndex, setTabIndex] = React.useState(9);
    const navigate = useNavigate();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <>
            <Grid container direction="column" alignItems="center">
                <Container>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h2>Con Reingreso</h2>
                    </div>
                </Container>
                <Container>
                    <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Paper square>
                            <AntTabs
                                value={tabIndex}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    style: { display: 'none' }, // O también puedes usar display: 'none' aquí
                                }}
                            >
                                <AntTab label="Resumen" />
                                <AntTab label="Tabla De Interés" />
                                <AntTab label="Tasas Por Año" />
                                <AntTab label="Monto Del Beneficio" />
                                <AntTab label="Datos" />
                                <AntTab label="Cálculos" />
                                <AntTab label="Rebajas" />
                                <AntTab label="Períodos" />
                                <AntTab label="Comparativa Devolución 10%" />
                                <AntTab label="Con Reingreso" />
                            </AntTabs>
                        </Paper>
                    </Box>

                    <Box mt={3}>
                        {/* Contenido de la pestaña actual */}
                        {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
                        {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
                        {tabIndex === 2 && navigate('/Separaciones/TasasLeyAnterior')}
                        {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
                        {tabIndex === 4 && navigate('Separaciones/LeyAnterior')}
                        {tabIndex === 5 && navigate('/Separaciones/CalculosLeyAnterior')}
                        {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
                        {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
                        {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
                        {tabIndex === 9}
                    </Box>
                </Container>
            </Grid>

            <Container style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <h2 style={{ textAlign: 'center' }}>Sección de Registro y Afiliación<br />Hoja de Revisión de Cálculo de Cotizaciones con Reingreso al Sistema</h2>
            </Container>

            <Box marginTop={2} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row">
                            <Grid container>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="participante"
                                        label="Paticipante"
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="identidad"
                                        label="Identidad"
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="cotizante"
                                        label="Cotizante"
                                        variant="outlined"
                                        InputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={2} boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Stack direction="row">
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="participante"
                                        label="Monto en Base al Cual se Firmo Convenio de Reingreso"
                                        variant="outlined"
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="identidad"
                                        label="Plazo de Amortización Establecido en el Convenio Reingreso (Meses)"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                        <Stack direction="row" style={{ marginTop: 10 }}>
                            <Grid container spacing={1}>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="participante"
                                        label="Cuotas Pagadas por Reingreso al Sistema (Meses)"
                                        variant="outlined"
                                    />
                                </FormControl>
                                <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                    <TextField
                                        id="identidad"
                                        label="Valor de las Cuotas a Pagar por Reingreso al Sistema"
                                        variant="outlined"
                                    />
                                </FormControl>
                            </Grid>
                        </Stack>

                    </CardContent>
                </Card>
            </Box>

            <div>
                <TableContainer component={Paper} style={{ marginTop: 30 }}>
                    {/* Tabla 2 */}
                    <Table>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center' }} colSpan={3}>
                                    <strong>Detalle Monto Convenio Reingreso</strong>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }} rowSpan={2}>
                                    <strong>Porcentual (%)</strong>
                                </StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center' }} colSpan={2}></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><b>Monetario</b></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>

                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}>Aportaciones Retiradas</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}>Intereses Retirados</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}>Interés Actuarial Por Cobrar</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}>Interés por Financiamiento</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}><b>TOTALES</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}>Menos Abono Parcial</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20, borderBottomColor: 'black' }} colSpan={2}>TOTAL</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', borderBottomColor: 'black' }}>
                                    <TextField variant="filled"
                                        InputProps={{
                                            disableUnderline: true,
                                            readOnly: true
                                        }} fullWidth>
                                    </TextField>
                                </StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', borderBottomColor: 'black' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Valor Pagado por Reingreso al Sistema</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Intereses Cobrados por Financiamiento</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Proporción Interés Actuarial a No Devolver</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>-</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Aportaciones Reingresadas al Sistema</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Intereses Reingresados al Sistema</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Proporción Interés Actuarial a Devolver</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>+</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}>Más Abono Parcial + Intereses A Devolver</StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={3}><b>TOTAL A DEVOLVER</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

                <TableContainer component={Paper} style={{ marginTop: 30 }}>
                    <Table>
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} ><b>Del</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}><b>Al</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}><b>Abono Parcial Pagado</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}><b>Interés</b></StyledTableCell>
                            </StyledTableRow>

                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} ></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}></StyledTableCell>
                            </StyledTableRow>

                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} ><b>Tiempo En Meses</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}><b>Factor</b></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}><b>Abono Parcial Mas Intereses a Devolver</b></StyledTableCell>
                            </StyledTableRow>

                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} ></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }}></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center', fontSize: 20 }} colSpan={2}></StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            <Stack direction="row" style={{ marginTop: '20px' }}>
                <Grid container>
                    <TextField
                        id="observaciones"
                        label="Observaciones"
                        variant="filled"
                        fullWidth
                    />
                </Grid>
            </Stack>

            <Stack direction="row" style={{ marginTop: '20px' }}>
                <Grid container>
                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                        <TextField
                            id="efectuadopor"
                            label="Cálculo Efectuado Por"
                            variant="filled"
                        />
                    </FormControl>
                    <FormControl sx={{ m: 1, flexGrow: 1 }}>
                        <TextField
                            id="actuaria"
                            label="V°.B°. Unidad De Actuaría"
                            variant="filled"
                        />
                    </FormControl>
                </Grid>
            </Stack>
        </>
    );
}